import React from "react";
import AllProspects from "./prospect/AllProspects";
import { NewTab, PageTabAdv } from "../../../components";
import { useModuleAccess } from "../../../hooks";
import MyTeamProspects from "./MyTeamProspects/MyTeamProspects";

const Prospects = () => {
  const prospectsMenus = [
    {
      title: "Prospects",
      page: <AllProspects />,
      type: "main",
      id: "prospects_propects",
    },
    {
      title: "My Team Prospects",
      page: <MyTeamProspects />,
      type: "main",
      id: "prospects_myteampropects",
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: prospectsMenus,
    parentId: "prospects",
  });
  console.log(filteredTabs, "filteredTabs");
  return (
    <div className="flex flex-1 overflow-hidden">
      <NewTab
        tabs={filteredTabs}
        color="black"
        variant="outlined"
        mode="url"
        tabId="prospects"
      />
    </div>
  );
};

export default Prospects;
